import { useMutation, Types } from "@grandvisionhq/graphql";
import { SET_PASSWORD } from "../../../operations/mutations/CreateAccount/operations/mutations/create-password.js";
const mapConsents = (selectedConsents) => selectedConsents.map((consent) => ({
  consentName: consent.value,
  literalText: consent.title,
  uiType: Types.UIType.CHECKBOX,
  value: true
}));
const useSetPassword = () => {
  const [setPassword, { data, loading, error }] = useMutation(SET_PASSWORD);
  const callback = ({ consents, ...rest }) => setPassword({
    variables: {
      input: {
        consents: mapConsents(consents),
        ...rest
      }
    }
  });
  return [
    callback,
    {
      customerId: data?.activateCustomerAccount?.customerId,
      loading,
      error
    }
  ];
};
export {
  useSetPassword
};
//# sourceMappingURL=use-create-password.js.map
